import { forwardRef } from "react"

export const BlockPlanComponenet = forwardRef(({ blockID }, ref) => {
  console.log("blockID", blockID)
  if (blockID === "E") {
    return <BlockE ref={ref} />
  } else if (blockID === "K") {
    return <BlockK ref={ref} />
  } else if (blockID === "F") {
    return <BlockF ref={ref} />
  } else return null
})

export const BlockF = forwardRef((props, ref) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" ref={ref} viewBox="0 0 532.92 340.92">
      <g id="Layer_2" data-name="Layer 2">
        <g id="block_f">
          <g id="static_element">
            <g id="green_space">
              <path
                d="M397.87,98.84l-280-.62-.5,57.18H103.75q.19,19.75.42,39.51l308.38,34.64Z"
                fill="#5c8067"
                opacity="0.3"
              />
            </g>
            <g id="icon-type-2">
              <circle cx="259.39" cy="155.5" r="50.58" fill="#cfc5c6" />
            </g>
            <g id="building_outlines">
              <path
                d="M450.86,310.26,438,142.18l12.82,168.08L508,320.57,495.4,140.05,421,142.18,422.58,158q4.94,47.24,9.88,94.48h.08l13.62,2.58-13.62-2.58h-.08q-4.93-47.25-9.88-94.48l9.24,94.48L82.3,207.63l-.63-66.43-13-.41,1.7,94-1.7-94L9.47,139l59.18,1.82,13,.41,15.93,0,.14-59.16,317.48.69L421,142.18l74.37-2.13L486.65,15,9.74,11.19l-.51,237L70.3,259.78l0-25,13.57.36,0,25.12,341,48.27,5.14-25.44,17,0,3.35,27.16L508,320.57ZM355.21,82.63,353.68,14Z"
                fill="none"
                stroke="#653387"
                strokeMiterlimit="10"
                strokeWidth="3.39"
              />
            </g>
            <g id="text-type-2">
              <text
                transform="translate(231.56 179.48)"
                fontSize="78.13"
                fill="#887697"
                fontFamily="Lora-Bold, Lora"
                fontWeight="700"
              >
                F
              </text>
            </g>
          </g>
          <g id="dynamic_element">
            <g id="dynamic_display">
              <g id="text-type-1">
                <g id="dynamic_value">
                  <text
                    id="apt_no_f"
                    transform="translate(342.27 179.48)"
                    fontSize="60"
                    fill="#887697"
                    fontFamily="Lora-Bold, Lora"
                    fontWeight="700"
                  >
                    0
                  </text>
                </g>
              </g>
            </g>
          </g>
          <g id="hidden_buttons">
            <g id="return_parent_id">
              <rect id="building_button_f1" width="532.92" height="340.92" fill="#887697" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
})

export const BlockK = forwardRef((props, ref) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" ref={ref} viewBox="0 0 532.92 340.92">
      <g id="Layer_2" data-name="Layer 2">
        <g id="block_k">
          <g id="static_element">
            <g id="green_space">
              <path
                d="M397.87,98.84l-280-.62-.5,57.18H103.75q.19,19.75.42,39.51l308.38,34.64Z"
                fill="#5c8067"
                opacity="0.3"
              />
            </g>
            <g id="icon-type-2">
              <circle cx="259.39" cy="155.5" r="50.58" fill="#cfc5c6" />
            </g>
            <g id="building_outlines">
              <path
                d="M450.86,310.26,438,142.18l12.82,168.08L508,320.57,495.4,140.05,421,142.18,422.58,158q4.94,47.24,9.88,94.48h.08l13.62,2.58-13.62-2.58h-.08q-4.93-47.25-9.88-94.48l9.24,94.48L82.3,207.63l-.63-66.43-13-.41,1.7,94-1.7-94L9.47,139l59.18,1.82,13,.41,15.93,0,.14-59.16,317.48.69L421,142.18l74.37-2.13L486.65,15,9.74,11.19l-.51,237L70.3,259.78l0-25,13.57.36,0,25.12,341,48.27,5.14-25.44,17,0,3.35,27.16L508,320.57ZM355.21,82.63,353.68,14Z"
                fill="none"
                stroke="#653387"
                strokeMiterlimit="10"
                strokeWidth="3.39"
              />
            </g>
            <g id="text-type-2">
              <text
                transform="translate(231.56 179.48)"
                fontSize="78.13"
                fill="#887697"
                fontFamily="Lora-Bold, Lora"
                fontWeight="700"
              >
                K
              </text>
            </g>
          </g>
          <g id="dynamic_element">
            <g id="dynamic_display">
              <g id="text-type-1">
                <g id="dynamic_value">
                  <text
                    id="apt_no_k"
                    transform="translate(342.27 179.48)"
                    fontSize="60"
                    fill="#887697"
                    fontFamily="Lora-Bold, Lora"
                    fontWeight="700"
                  >
                    0
                  </text>
                </g>
              </g>
            </g>
          </g>
          <g id="hidden_buttons">
            <g id="return_parent_id">
              <rect id="building_button_k1" width="532.92" height="340.92" fill="#887697" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
})

export const BlockC = forwardRef((props, ref) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" ref={ref} viewBox="0 0 532.92 340.92" width="100%">
      <g id="block_c">
        <g id="static_element">
          <g id="green_space">
            <polygon
              id="green_space-2"
              data-name="green_space"
              points="323.32 122.34 322.85 334.09 155.18 332.86 155.65 121.98 323.32 122.34"
              fill="#5c7f66"
              opacity="0.3"
            />
          </g>
          <g id="icon-type-2">
            <circle cx="238.69" cy="228.03" r="50.58" fill="#cfc5c6" />
          </g>
          <g id="building_outlines">
            <polygon
              points="1.5 2.5 125.26 2.27 125.25 145.2 111.6 145.18 111.44 168.78 1.5 169.2 1.5 2.5"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polygon
              points="125.9 2.32 125.89 75.73 349.26 75.73 349.33 2.55 125.9 2.32"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polygon
              points="348.69 1.5 473.77 1.5 473.77 167.01 364.43 167.12 364.43 143.45 348.65 143.45 348.69 1.5"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polygon
              points="16.55 169.87 111.44 170.41 111.29 191.62 125.25 191.68 125.25 334.16 1.5 334.16 1.5 206.62 16.78 206.39 16.55 169.87"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polyline
              points="364.46 167 458.02 166.89 458.02 205.21 473.74 205.14 473.77 327.43 348.65 327.43 348.65 190.46 364.43 190.46 364.46 167"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.46"
            />
          </g>
          <g id="text-type-2">
            <text
              transform="translate(84.15 159.04)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              4
            </text>
            <text
              transform="translate(322.56 69.01)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              5
            </text>
            <text
              transform="translate(446.85 154.76)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              1
            </text>
            <text
              transform="translate(100.54 325.68)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              3
            </text>
            <text
              transform="translate(446.85 318.45)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              2
            </text>
            <text
              transform="translate(209.04 252.01)"
              fontSize="78.13"
              fill="#887597"
              fontFamily="Lora-Bold, Lora"
              fontWeight="700"
            >
              C
            </text>
          </g>
        </g>
        <g id="dynamic_element">
          <g id="dynamic_display">
            <g id="text-type-1">
              <g id="dynamic_value">
                <text
                  id="apt_no_c4"
                  transform="translate(46.79 109.15)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
                <text
                  id="apt_no_c5"
                  transform="translate(214.54 66.19)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
                <text
                  id="apt_no_c1"
                  transform="translate(391.27 109.15)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
                <text
                  id="apt_no_c3"
                  transform="translate(47.27 279.09)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
                <text
                  id="apt_no_c2"
                  transform="translate(392.14 278.61)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
              </g>
            </g>
          </g>
        </g>
        <g id="hidden_buttons">
          <g id="return_parent_id">
            <polygon
              id="building_button_c4"
              points="1.5 2.5 125.26 2.27 125.25 145.2 111.6 145.18 111.44 168.78 1.5 169.2 1.5 2.5"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polygon
              id="building_button_c5"
              points="125.9 2.32 125.89 75.73 349.26 75.73 349.33 2.55 125.9 2.32"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polygon
              id="building_button_c1"
              points="348.69 1.5 473.77 1.5 473.77 167.01 364.43 167.12 364.43 143.45 348.65 143.45 348.69 1.5"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polygon
              id="building_button_c3"
              points="16.55 169.87 111.44 170.41 111.29 191.62 125.25 191.68 125.25 334.16 1.5 334.16 1.5 206.62 16.78 206.39 16.55 169.87"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polyline
              id="building_button_c2"
              points="364.46 167 458.02 166.89 458.02 205.21 473.74 205.14 473.77 327.43 348.65 327.43 348.65 190.46 364.43 190.46 364.46 167"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.46"
            />
          </g>
        </g>
      </g>
    </svg>
  )
})
export const BlockE = forwardRef((props, ref) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" ref={ref} viewBox="0 0 532.92 340.92" width="100%">
      <g id="block_e">
        <g id="static_element">
          <g id="green_space">
            <path
              d="M397.87,98.84l-280-.62-.5,57.18H103.75q.19,19.75.42,39.51l308.38,34.64Z"
              fill="#5c7f66"
              opacity="0.3"
            />
          </g>
          <g id="icon-type-2">
            <circle cx="259.39" cy="155.5" r="50.58" fill="#cfc5c6" />
          </g>
          <g id="building_outlines">
            <path
              d="M450.86,310.26,438,142.18l12.82,168.08L508,320.57,495.4,140.05,421,142.18,422.58,158q4.94,47.24,9.88,94.48h.08l13.62,2.58-13.62-2.58h-.08q-4.93-47.25-9.88-94.48l9.24,94.48L82.3,207.63l-.63-66.43-13-.41,1.7,94-1.7-94L9.47,139l59.18,1.82,13,.41,15.93,0,.14-59.16,317.48.69L421,142.18l74.37-2.13L486.65,15,9.74,11.19l-.51,237L70.3,259.78l0-25,13.57.36,0,25.12,341,48.27,5.14-25.44,17,0,3.35,27.16L508,320.57ZM355.21,82.63,353.68,14Z"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.39"
            />
          </g>
          <g id="text-type-2">
            <text
              transform="translate(235.01 179.48)"
              fontSize="78.13"
              fill="#887597"
              fontFamily="Lora-Bold, Lora"
              fontWeight="700"
            >
              E
            </text>
          </g>
        </g>
        <g id="dynamic_element">
          <g id="dynamic_display">
            <g id="text-type-1">
              <g id="dynamic_value">
                <text
                  id="apt_no_e"
                  transform="translate(342.27 179.48)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
              </g>
            </g>
          </g>
        </g>
        <g id="hidden_buttons">
          <g id="return_parent_id">
            <rect id="building_button_e1" width="532.92" height="340.92" fill="#887597" />
          </g>
        </g>
      </g>
    </svg>
  )
})

export const SvgSitePlan = forwardRef((props, ref) => {
  return (
    <svg
      // style={{ border: "red solid 1px" }}
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      // height="80.28mm"
      onClick={e => {
        e.stopPropagation()
        console.log(e)
      }}
      viewBox="0 0 246.98 227.56"
    >
      <g id="Layer_1" data-name="Layer 1">
        <g id="Layer_2" data-name="Layer 2">
          <g id="static_element" data-name="static element">
            <polygon
              points="46.06 55.77 59.7 59.12 49.8 100.29 52.8 100.87 53.24 98.93 63.14 97.63 64.79 107.93 57.87 108.94 57.62 110.14 34.41 104.56 46.06 55.77"
              fill="#79a9a6"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".9"
              />
            <polygon
              points="62.1 53.72 75.07 51.54 75.37 52.65 75.92 52.43 84.24 104.52 83.52 104.62 83.84 105.88 70.7 107.94 62.1 53.72"
              fill="#79a9a6"
              stroke="#000"
              
            
              strokeLinecap="round"
              strokeWidth=".9"
              strokeLinejoin="round"
              
            />
            <path
              d="M205.58,23.27l-.87-2.04-1.81-1.61-2.16-.84-2.72,.19-110.6,26.16,13.62,57.68,33.12-7.72,.61,2.22,28.36-6.73,.63,2.5,28.34-6.73,.48,2.24,26.95-6.39-13.94-58.93Zm-22.66,53.25l-.24-2.24-21.62,5.18-.48-2.2-28.34,6.69-.63-2.22-12.7,3.01-5.61-23.6,74.85-17.7,7.1,30.22-12.34,2.87Z"
              fill="#d9d9d9"
              stroke="#bfbfbf"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".2"
            />
            <polygon
              points="40.24 148.49 48.07 124.53 42.34 148.93 40.24 148.49"
              fill="none"
              stroke="#79a9a6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <polyline
              points="14.56 185.47 16.34 200.66 14.56 185.47 16.27 192.15 24.04 194.05 24.57 191.8 31.34 190.48 41.44 192.06 49.6 151.95 52.79 152.56 55.21 154.2 57.61 153.76 62.8 185.22 88.83 181.32 87.97 175.03 126.44 168.52 127.54 175.17 149.4 171.47 148.7 166.2 218.34 154.17 220.59 166.84 16.33 200.66"
              fill="none"
              stroke="#bfbfbf"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <polygon
              points="61.27 115.38 55.54 112.98 41.34 115.38 36.2 137.29 38.7 137.85 46 117.91 61.27 115.38"
              fill="none"
              stroke="#bfbfbf"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <rect
              x="124.1"
              y="58.98"
              width="60.09"
              height="14.06"
              transform="translate(-11.03 37.1) rotate(-13.25)"
              fill="none"
              stroke="#bfbfbf"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <polygon
              points="97.36 98.36 91.62 99.42 88.08 80.28 92.82 79.21 97.36 98.36"
              fill="none"
              stroke="#bfbfbf"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="28.34"
              y1="301.87"
              x2="14.65"
              y2="186.56"
              fill="none"
              stroke="#bfbfbf"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".32"
            />
            <line
              x1="212.83"
              y1="126.51"
              x2="212.44"
              y2="123.83"
              fill="none"
              stroke="#bfbfbf"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".32"
            />
            <line
              x1="212.44"
              y1="123.83"
              x2="230.4"
              y2="121.21"
              fill="none"
              stroke="#bfbfbf"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".32"
            />
            <line
              x1="252.11"
              y1="212.67"
              x2="229.34"
              y2="215.99"
              fill="none"
              stroke="#bfbfbf"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".32"
            />
            <line
              x1="229.33"
              y1="215.99"
              x2="217.36"
              y2="148.68"
              fill="none"
              stroke="#bfbfbf"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".32"
            />
            <line
              x1="229.33"
              y1="215.99"
              x2="131.28"
              y2="232.01"
              fill="none"
              stroke="#bfbfbf"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".32"
            />
            <line
              x1="230.41"
              y1="121.21"
              x2="252.11"
              y2="212.67"
              fill="none"
              stroke="#bfbfbf"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".32"
            />
            <path
              d="M261.35,227.75l-12.79-56.8-10.15-41.61-9.52-39.64-15.85-66.44-2.26-6.88-4.15-4.32-4.83-1.59-6.27,.63-53.99,12.22-69.37,12.27-27.01,10.19-3.67,1.94-2.41,3.81-10.08,54.87-4.83,24.65-6.92,28.13-4.7,22.68-.71,5.32v4.53l3.09,34.48,6.15,52.62,3.54,32.15,1.27,7.19,11.84,44.34-15.07-.3,.52-1.82-1.94-9.35-7.95-34.64c-2.29-39.86-10.53-110.32-10.95-116.16-.42-5.85-1.51-13.9-.12-19.64,1.38-5.73,10.9-47.55,10.9-47.55L29.15,55.77l-.14-1.31-99.56,46.41h-9.02L-70.55,6.21V80.83l4.26,3.12,5.5,.63L28.23,46.61l3.6-4.13,4.98-28.08-1.66-3.91L-17.12-.6-8.75-28.07l67.37,2.7-7.33,39.76,2.83,2.56,23.63,5.63L163.75,6.21,191.42-.6l3-3.48,1.11-3.84-.95-3.3-10.38-16.85,21.83,1.16,12.48,20.99,2.92,3.18,4.8,1.1,15.03,1.05,12.9-.14,24.62,6.95-45.36,4.27-3.36,1.8-.53,3.49,23.55,100.66,25.69,112.39"
              fill="#D0D0D0"
              stroke="#AAAAAA"
            />
            <polygon
              points="226.63 110.25 101.07 131.57 97.36 109.72 220.87 88.74 226.63 110.25"
              fill="#dee7e5"
              stroke="#bfbfbf"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <polyline
              points="46.75 151.41 52.79 152.56 55.21 154.2 59.61 153.47"
              fill="#f2f2f2"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="34.4"
              y1="104.56"
              x2="57.6"
              y2="110.14"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="57.62"
              y1="110.14"
              x2="57.87"
              y2="108.94"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="57.86"
              y1="108.94"
              x2="64.79"
              y2="107.93"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="64.79"
              y1="107.93"
              x2="63.14"
              y2="97.63"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="63.14"
              y1="97.63"
              x2="54.11"
              y2="99.09"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="54.13"
              y1="99.09"
              x2="53.24"
              y2="98.93"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="53.23"
              y1="98.93"
              x2="52.8"
              y2="100.87"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="52.79"
              y1="100.87"
              x2="49.81"
              y2="100.29"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="49.8"
              y1="100.29"
              x2="59.7"
              y2="59.12"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="59.7"
              y1="59.12"
              x2="46.06"
              y2="55.77"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="46.07"
              y1="55.77"
              x2="34.41"
              y2="104.56"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="70.7"
              y1="107.94"
              x2="83.84"
              y2="105.88"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="83.84"
              y1="105.88"
              x2="83.52"
              y2="104.62"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="83.53"
              y1="104.62"
              x2="84.24"
              y2="104.52"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="84.24"
              y1="104.52"
              x2="75.92"
              y2="52.43"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="75.91"
              y1="52.43"
              x2="75.37"
              y2="52.65"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="75.38"
              y1="52.65"
              x2="75.07"
              y2="51.54"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="75.08"
              y1="51.54"
              x2="62.1"
              y2="53.72"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="62.1"
              y1="53.72"
              x2="70.72"
              y2="107.94"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="61.27"
              y1="115.38"
              x2="81.74"
              y2="112.11"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="85.56"
              y1="136.4"
              x2="65.11"
              y2="139.81"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="61.25"
              y1="115.38"
              x2="65.1"
              y2="139.81"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="101.03"
              y1="102.8"
              x2="134.15"
              y2="95.08"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="134.13"
              y1="95.08"
              x2="134.75"
              y2="97.3"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="134.77"
              y1="97.3"
              x2="163.11"
              y2="90.57"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="163.11"
              y1="90.57"
              x2="163.76"
              y2="93.07"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="163.75"
              y1="93.07"
              x2="192.09"
              y2="86.34"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="192.09"
              y1="86.34"
              x2="192.56"
              y2="88.58"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="192.56"
              y1="88.59"
              x2="219.51"
              y2="82.2"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="219.51"
              y1="82.2"
              x2="205.58"
              y2="23.27"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="205.58"
              y1="23.27"
              x2="204.7"
              y2="21.23"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="204.71"
              y1="21.23"
              x2="202.89"
              y2="19.62"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="202.88"
              y1="19.62"
              x2="200.73"
              y2="18.77"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="200.75"
              y1="18.77"
              x2="198.47"
              y2="18.96"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="198.45"
              y1="18.96"
              x2="87.41"
              y2="45.12"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="87.42"
              y1="45.12"
              x2="101.03"
              y2="102.8"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="118.91"
              y1="84.73"
              x2="113.3"
              y2="61.14"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="113.29"
              y1="61.13"
              x2="188.15"
              y2="43.43"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="188.16"
              y1="43.43"
              x2="195.32"
              y2="73.74"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="195.32"
              y1="73.74"
              x2="183.15"
              y2="76.52"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="183.15"
              y1="76.52"
              x2="182.67"
              y2="74.28"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="182.68"
              y1="74.28"
              x2="161.05"
              y2="79.46"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="161.04"
              y1="79.45"
              x2="160.57"
              y2="77.21"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="160.58"
              y1="77.21"
              x2="132.24"
              y2="83.95"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="132.24"
              y1="83.95"
              x2="131.62"
              y2="81.72"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="131.61"
              y1="81.72"
              x2="118.9"
              y2="84.73"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="24.05"
              y1="194.05"
              x2="16.26"
              y2="192.15"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="16.27"
              y1="192.15"
              x2="14.57"
              y2="185.47"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="47.08"
              y1="149.95"
              x2="42.83"
              y2="168.34"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="42.84"
              y1="168.34"
              x2="44.33"
              y2="168.7"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="44.33"
              y1="168.7"
              x2="39.81"
              y2="189.15"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="39.8"
              y1="189.15"
              x2="24.59"
              y2="191.81"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="24.57"
              y1="191.8"
              x2="24.04"
              y2="194.05"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="14.55"
              y1="185.47"
              x2="23.82"
              y2="144.97"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="64.8"
              y1="185.22"
              x2="59.5"
              y2="152.77"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="59.49"
              y1="152.77"
              x2="68.82"
              y2="151.41"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="68.82"
              y1="151.41"
              x2="68.1"
              y2="146.46"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="68.12"
              y1="146.46"
              x2="87.35"
              y2="143.65"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="87.35"
              y1="143.65"
              x2="87.99"
              y2="148.04"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="87.97"
              y1="148.04"
              x2="92.07"
              y2="147.44"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="92.07"
              y1="147.44"
              x2="91.84"
              y2="145.88"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="91.85"
              y1="145.88"
              x2="122.61"
              y2="140.82"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="122.61"
              y1="140.82"
              x2="122.18"
              y2="137.85"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="122.17"
              y1="137.85"
              x2="141.55"
              y2="135.03"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="141.55"
              y1="135.03"
              x2="141.96"
              y2="137.86"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="141.97"
              y1="137.85"
              x2="158.65"
              y2="135.42"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="158.65"
              y1="135.42"
              x2="158.14"
              y2="131.89"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="217.36"
              y1="148.68"
              x2="181.7"
              y2="154.74"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="181.7"
              y1="154.74"
              x2="182.23"
              y2="158.42"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="182.23"
              y1="158.42"
              x2="163.07"
              y2="161.79"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="163.09"
              y1="161.79"
              x2="162.65"
              y2="158.82"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="162.65"
              y1="158.82"
              x2="141.24"
              y2="162.52"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="141.22"
              y1="162.52"
              x2="141.76"
              y2="166.2"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="141.77"
              y1="166.2"
              x2="144.59"
              y2="165.79"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="144.59"
              y1="165.79"
              x2="145.54"
              y2="172.29"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="145.54"
              y1="172.29"
              x2="129.76"
              y2="175.03"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="129.76"
              y1="175.03"
              x2="128.1"
              y2="164.58"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="128.1"
              y1="164.58"
              x2="90.31"
              y2="170.96"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="90.32"
              y1="170.96"
              x2="89.78"
              y2="167.28"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="89.78"
              y1="167.28"
              x2="83.7"
              y2="168.17"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="83.69"
              y1="168.17"
              x2="85.74"
              y2="182.17"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="85.74"
              y1="182.17"
              x2="64.8"
              y2="185.22"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="217.36"
              y1="148.68"
              x2="212.83"
              y2="126.51"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
          </g>
          <g id="block_e" data-name="block e">
            <line
              x1="23.82"
              y1="144.36"
              x2="29.06"
              y2="143.6"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="29.06"
              y1="143.6"
              x2="29.59"
              y2="147.28"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="29.59"
              y1="147.28"
              x2="29.17"
              y2="149.36"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="29.19"
              y1="149.36"
              x2="32.74"
              y2="150"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="32.73"
              y1="150"
              x2="33.52"
              y2="146.42"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="33.52"
              y1="146.42"
              x2="47.08"
              y2="149.35"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <polygon
              points="23.82 144.36 29.06 143.6 29.59 147.28 29.17 149.36 32.73 150 33.52 146.42 47.08 149.35 42.83 167.74 44.33 168.1 39.81 188.55 24.57 191.2 24.04 193.45 16.27 191.55 14.55 184.86 23.82 144.36"
              fill="#b3ccc8"
            />
            <polygon
              points="23.82 144.36 29.06 143.6 29.59 147.28 29.17 149.36 32.73 150 33.52 146.42 47.08 149.35 42.83 167.74 44.33 168.1 39.81 188.55 24.57 191.2 24.04 193.45 16.27 191.55 14.55 184.86 23.82 144.36"
              fill="#7aaaa6"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="1.25"
            />
            <g id="text-type-2-2">
              <g id="E">
                <path
                  d="M25.76,178.16v-13h7.52v1.55h-5.85v4h5.09v1.49h-5.09v4.48h6v1.55l-7.67-.07Z"
                  fill="#77797c"
                />
              </g>
            </g>
            <g id="hidden_buttons-2" data-name="hidden buttons-2">
              <g id="return_parent_id-2" data-name="return parent id-2">
                <rect
                  id="button_e"
                  data-name="button e"
                  x="5.23"
                  y="149.71"
                  width="53.93"
                  height="38.83"
                  transform="translate(-138.45 146.39) rotate(-71.63)"
                  fill="#D0D0D0"
                  stroke="#AAAAAA"
                />
              </g>
            </g>
          </g>
          <g id="block_k" data-name="block k">
            <line
              x1="81.49"
              y1="112.66"
              x2="85.32"
              y2="136.95"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <polygon
              points="61.02 115.93 81.49 112.66 85.32 136.95 64.86 140.37 61.02 115.93"
              fill="#7aaaa6"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="1.25"
            />
            <g id="text-type-2">
              <path
                d="M68.16,132.48v-13h1.71v5.9h0l5.69-5.92h2.12l-5.85,6,6.35,7h-2.23l-6.08-6.73h0v6.75h-1.71Z"
                fill="#77797c"
              />
            </g>
            <g id="hidden_buttons-2-2" data-name="hidden buttons-2">
              <g id="return_parent_id-2-2" data-name="return parent id-2">
                <rect
                  id="button_k"
                  data-name="button k"
                  x="59.16"
                  y="110.16"
                  width="32.43"
                  height="32.71"
                  fill="#D0D0D0"
                  stroke="#AAAAAA"
                />
              </g>
            </g>
          </g>
          <g id="block_f" data-name="block f">
            <line
              x1="157.87"
              y1="132.37"
              x2="177.25"
              y2="129.55"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="177.25"
              y1="129.55"
              x2="177.71"
              y2="132.66"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <line
              x1="177.7"
              y1="132.66"
              x2="212.56"
              y2="127"
              fill="none"
              stroke="gray"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".28"
            />
            <polygon
              points="91.57 146.37 122.33 141.3 121.9 138.33 141.26 135.51 141.68 138.34 158.37 135.9 157.86 132.37 177.25 129.54 177.7 132.65 212.55 127 217.08 149.16 181.42 155.23 181.95 158.9 162.8 162.27 162.37 159.3 140.95 163 140.94 163 141.48 166.68 144.31 166.27 145.26 172.78 129.48 175.51 127.81 165.06 90.04 171.44 89.5 167.76 83.42 168.65 83.41 168.65 85.45 182.65 64.52 185.7 59.33 153.95 59.32 153.95 59.21 153.25 68.54 151.89 67.81 146.94 67.84 146.94 87.07 144.13 87.71 148.52 91.79 147.92 91.56 146.37 91.57 146.37"
              fill="#79a9a6"
            />
            <polygon
              points="91.57 146.37 122.33 141.3 121.9 138.33 141.26 135.51 141.68 138.34 158.37 135.9 157.86 132.37 177.25 129.54 177.7 132.65 212.55 127 217.08 149.16 181.42 155.23 181.95 158.9 162.8 162.27 162.37 159.3 140.95 163 140.94 163 141.48 166.68 144.31 166.27 145.26 172.78 129.48 175.51 127.81 165.06 90.04 171.44 89.5 167.76 83.42 168.65 83.41 168.65 85.45 182.65 64.52 185.7 59.33 153.95 59.32 153.95 59.21 153.25 68.54 151.89 67.81 146.94 67.84 146.94 87.07 144.13 87.71 148.52 91.79 147.92 91.56 146.37 91.57 146.37"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.25"
            />
            <path
              d="M133.1,146.74h7.01v1.41h-5.33v4.33h4.93v1.39h-4.93v5.89h-1.68v-13.02Z"
              fill="#787a7c"
            />
            <g id="hidden_buttons-2-3" data-name="hidden buttons-2">
              <g id="return_parent_id-2-3" data-name="return parent id-2">
                <rect
                  id="button_f"
                  data-name="button f"
                  x="58.74"
                  y="135.82"
                  width="166.94"
                  height="37.77"
                  transform="translate(-21.8 23.33) rotate(-8.71)"
                  fill="#D0D0D0"
                  stroke="#AAAAAA"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g id="RoadsBackground">
        <g>
          <path
            d="M12.14,151.62l.21-1.02c.09-.42,.19-.81,.44-1.11,.26-.3,.62-.46,1.08-.36,.44,.09,.74,.38,.86,.73,.13,.38,.06,.84-.05,1.34l-.08,.4,1.54,.32-.11,.51-3.89-.81Zm2.11-.58c.09-.46,.13-.72,.05-.96-.08-.22-.25-.38-.51-.43-.29-.06-.52,.04-.68,.23-.17,.21-.23,.5-.31,.86l-.1,.46,1.45,.3,.1-.47Z"
            fill="#77787b"
          />
          <path
            d="M13.17,146.66l.11-.51,1.64,.34,.44-2.12-1.64-.34,.11-.51,3.89,.81-.11,.51-1.79-.37-.44,2.12,1.79,.37-.11,.51-3.89-.81Z"
            fill="#77787b"
          />
          <path
            d="M14.66,139.26c.24-1.13,1.29-1.8,2.42-1.56,1.13,.24,1.83,1.27,1.59,2.4-.24,1.13-1.29,1.8-2.42,1.56-1.13-.24-1.83-1.27-1.59-2.4Zm3.54,.74c.18-.85-.37-1.61-1.23-1.79-.86-.18-1.66,.3-1.84,1.15-.18,.85,.37,1.61,1.23,1.79,.85,.18,1.66-.3,1.84-1.15Z"
            fill="#77787b"
          />
          <path
            d="M15.6,135.02l.47-2.25,.46,.1-.36,1.74,1.18,.25,.32-1.52,.45,.09-.32,1.52,1.34,.28,.37-1.79,.46,.1-.48,2.3-3.89-.81Z"
            fill="#77787b"
          />
          <path
            d="M20.45,131.25l-3.89-.81,.1-.48,2.5-1.18c.34-.16,.7-.33,1.05-.48h0c-.34-.08-.73-.15-1.11-.23l-1.96-.41,.1-.5,3.89,.81-.1,.48-2.5,1.18c-.34,.16-.7,.33-1.05,.48h0c.34,.08,.73,.15,1.11,.23l1.96,.41-.1,.5Z"
            fill="#77787b"
          />
          <path d="M17.76,124.67l.11-.51,3.89,.81-.11,.51-3.89-.81Z" fill="#77787b" />
          <path
            d="M20.42,121.04l-2.1,.9,.13-.61,.99-.42c.23-.1,.46-.2,.71-.29h0c-.19-.2-.37-.39-.54-.56l-.73-.77,.12-.57,1.56,1.66,2.37-1.03-.13,.61-1.22,.53c-.25,.11-.5,.21-.74,.31h0c.18,.19,.37,.38,.54,.57l.92,.98-.12,.58-1.76-1.89Z"
            fill="#77787b"
          />
          <path
            d="M20.07,113.58l.21-1.02c.09-.41,.19-.81,.44-1.11,.26-.3,.62-.46,1.08-.36,.44,.09,.74,.38,.86,.73,.13,.38,.06,.84-.05,1.34l-.08,.4,1.54,.32-.11,.51-3.89-.81Zm2.11-.58c.09-.46,.13-.72,.05-.96-.08-.22-.25-.38-.51-.43-.29-.06-.52,.04-.68,.23-.17,.21-.23,.5-.31,.86l-.1,.46,1.45,.3,.1-.47Z"
            fill="#77787b"
          />
          <path
            d="M21.1,108.62l.11-.51,3.43,.71,.38-1.84,.46,.1-.49,2.35-3.89-.81Z"
            fill="#77787b"
          />
          <path
            d="M22.3,102.86l.1-.49,4.23-.8-.11,.55-1.18,.21-.37,1.75,.99,.67-.11,.52-3.56-2.41Zm2.26,.96l.29-1.4-.87,.15c-.34,.06-.7,.12-1.04,.17h0c.29,.19,.59,.39,.9,.6l.72,.48Z"
            fill="#77787b"
          />
          <path
            d="M23.49,96.86c.08-.41,.27-.77,.5-1.04l.56,.12c-.28,.25-.5,.61-.59,1.03-.18,.89,.35,1.65,1.22,1.83,.87,.18,1.66-.3,1.86-1.23,.09-.43,.02-.84-.16-1.2l.56,.12c.13,.35,.15,.8,.06,1.21-.25,1.18-1.28,1.86-2.42,1.62-1.11-.23-1.85-1.23-1.59-2.45Z"
            fill="#77787b"
          />
          <path
            d="M24.27,93.4l.47-2.25,.46,.1-.36,1.74,1.18,.25,.32-1.52,.45,.09-.32,1.52,1.34,.28,.37-1.79,.46,.1-.48,2.3-3.89-.81Z"
            fill="#77787b"
          />
        </g>
        <g>
          <path
            d="M224.86,22.88l.52,2.29-.46,.1-.41-1.78-1.25,.29,.36,1.57-.45,.1-.36-1.57-1.72,.39-.12-.51,3.88-.88Z"
            fill="#77787b"
          />
          <path
            d="M226.17,28.66l.11,.49-3.51,2.48-.12-.55,.98-.68-.4-1.75-1.18-.19-.12-.52,4.24,.71Zm-2.46,.07l.32,1.39,.73-.5c.28-.19,.59-.4,.88-.59h0c-.34-.06-.7-.11-1.06-.17l-.86-.14Z"
            fill="#77787b"
          />
          <path
            d="M227.12,32.82l.24,1.05c.09,.39,.16,.77,.05,1.13-.1,.36-.35,.64-.78,.74-.42,.1-.78-.04-1.02-.29-.12-.12-.2-.25-.26-.41l-1.43,1.63-.14-.62,1.39-1.56-.15-.66-1.66,.38-.12-.51,3.88-.88Zm-1.53,1.58c.08,.34,.18,.57,.35,.72,.14,.12,.32,.17,.54,.12,.25-.06,.41-.21,.48-.44,.06-.23,.02-.48-.06-.86l-.11-.5-1.34,.3,.15,.66Z"
            fill="#77787b"
          />
          <path
            d="M228.27,37.89l.24,1.05c.09,.39,.16,.77,.05,1.13-.1,.36-.35,.64-.78,.74-.42,.1-.78-.04-1.02-.29-.12-.12-.2-.25-.26-.41l-1.43,1.63-.14-.62,1.39-1.56-.15-.66-1.66,.38-.12-.51,3.88-.88Zm-1.53,1.58c.08,.34,.18,.57,.35,.72,.14,.12,.32,.17,.53,.12,.25-.06,.41-.21,.48-.44,.06-.24,.02-.48-.06-.86l-.11-.5-1.34,.3,.15,.66Z"
            fill="#77787b"
          />
          <path d="M229.43,42.97l.12,.51-3.88,.88-.12-.51,3.88-.88Z" fill="#77787b" />
          <path
            d="M226.23,46.84l3.88-.88,.11,.48-1.78,2.11c-.24,.29-.5,.59-.75,.88h0c.34-.07,.73-.17,1.1-.25l1.95-.44,.11,.49-3.88,.88-.11-.48,1.78-2.11c.24-.29,.5-.59,.75-.88h0c-.34,.07-.73,.17-1.1,.25l-1.95,.44-.11-.49Z"
            fill="#77787b"
          />
          <path
            d="M231.89,53.52c.11,.5,.06,.94-.05,1.26l-.58,.13c.19-.37,.26-.84,.16-1.3-.21-.91-1.02-1.37-1.87-1.18-.82,.19-1.4,.93-1.19,1.89,.07,.3,.2,.56,.36,.75l.91-.21-.2-.87,.44-.1,.31,1.38-1.6,.36c-.31-.29-.58-.76-.7-1.25-.26-1.15,.38-2.2,1.53-2.46,1.14-.26,2.2,.38,2.47,1.59Z"
            fill="#77787b"
          />
          <path
            d="M232.68,57.25l.24,1.07c.12,.51,.14,1,0,1.44-.21,.63-.73,1.08-1.41,1.23-.64,.15-1.28,0-1.74-.42-.38-.35-.6-.84-.75-1.51l-.21-.94,3.88-.88Zm-3.19,1.79c.11,.47,.25,.83,.52,1.09,.32,.32,.82,.47,1.36,.35,.56-.13,.92-.5,1.07-.9,.15-.39,.1-.81,0-1.23l-.11-.5-2.96,.67,.12,.51Z"
            fill="#77787b"
          />
          <path
            d="M234.4,64.54c.26,1.12-.42,2.17-1.55,2.43-1.12,.26-2.19-.39-2.45-1.52s.42-2.17,1.55-2.43c1.13-.26,2.19,.39,2.45,1.52Zm-3.52,.8c.19,.85,1.01,1.31,1.86,1.11,.85-.19,1.39-.96,1.19-1.81-.19-.85-1.01-1.31-1.86-1.12-.85,.19-1.39,.96-1.19,1.81Z"
            fill="#77787b"
          />
          <path
            d="M231.42,69.67l3.88-.88,.11,.48-1.78,2.11c-.24,.29-.5,.59-.75,.88h0c.34-.07,.73-.17,1.1-.25l1.95-.44,.11,.49-3.88,.88-.11-.48,1.78-2.11c.24-.29,.5-.59,.75-.88h0c-.34,.07-.73,.17-1.1,.25l-1.95,.44-.11-.49Z"
            fill="#77787b"
          />
          <path
            d="M237.27,77.44l.24,1.05c.09,.39,.16,.77,.05,1.13-.1,.36-.35,.64-.78,.74-.42,.1-.78-.04-1.02-.29-.12-.12-.2-.25-.26-.41l-1.43,1.63-.14-.62,1.39-1.56-.15-.66-1.66,.38-.12-.51,3.88-.88Zm-1.53,1.58c.08,.34,.18,.57,.35,.72,.14,.12,.32,.17,.53,.12,.25-.06,.41-.21,.48-.44,.06-.23,.02-.48-.06-.86l-.11-.5-1.34,.3,.15,.66Z"
            fill="#77787b"
          />
          <path
            d="M238.88,84.26c.26,1.12-.42,2.17-1.55,2.43s-2.19-.39-2.45-1.52,.42-2.17,1.55-2.43c1.13-.26,2.19,.39,2.45,1.52Zm-3.52,.8c.19,.85,1.01,1.31,1.86,1.12,.85-.19,1.39-.96,1.19-1.81-.19-.85-1.01-1.31-1.86-1.12-.85,.19-1.39,.96-1.19,1.81Z"
            fill="#77787b"
          />
          <path
            d="M240.06,89.69l.11,.49-3.51,2.48-.12-.55,.98-.68-.4-1.75-1.18-.19-.12-.52,4.24,.71Zm-2.46,.07l.32,1.39,.73-.5c.28-.19,.58-.4,.87-.59h0c-.34-.06-.7-.11-1.06-.17l-.86-.14Z"
            fill="#77787b"
          />
          <path
            d="M241.01,93.85l.24,1.07c.12,.51,.14,1,0,1.44-.21,.63-.73,1.08-1.41,1.23-.64,.15-1.28,0-1.74-.42-.38-.35-.6-.84-.75-1.51l-.21-.94,3.88-.88Zm-3.19,1.8c.11,.47,.25,.83,.52,1.09,.32,.32,.82,.47,1.36,.35,.56-.13,.92-.5,1.07-.9,.15-.39,.1-.81,0-1.23l-.11-.5-2.96,.67,.12,.51Z"
            fill="#77787b"
          />
        </g>
        <g>
          <path
            d="M86.88,25.15c.41-.08,.81-.05,1.15,.07l.11,.56c-.33-.16-.76-.23-1.18-.15-.89,.17-1.39,.96-1.22,1.83,.17,.87,.92,1.42,1.85,1.24,.43-.08,.79-.3,1.05-.61l.11,.57c-.27,.26-.68,.44-1.09,.52-1.19,.23-2.21-.47-2.43-1.61-.21-1.11,.42-2.18,1.65-2.41Z"
            fill="#77787b"
          />
          <path
            d="M91.57,24.32l.49-.09,2.36,3.6-.55,.1-.64-1.01-1.76,.33-.24,1.17-.52,.1,.86-4.21Zm-.01,2.46l1.4-.27-.47-.75c-.18-.29-.38-.6-.56-.9h0c-.06,.34-.12,.7-.2,1.06l-.17,.85Z"
            fill="#77787b"
          />
          <path
            d="M95.76,23.52l.51-.1,.66,3.44,1.85-.35,.09,.46-2.36,.45-.75-3.91Z"
            fill="#77787b"
          />
          <path
            d="M101.41,22.92l-1.31,.25-.09-.46,3.13-.6,.09,.46-1.31,.25,.66,3.44-.51,.1-.66-3.44Z"
            fill="#77787b"
          />
          <path
            d="M105.32,21.7l.51-.1,.31,1.65,2.13-.41-.31-1.65,.51-.1,.75,3.91-.51,.1-.34-1.8-2.13,.41,.34,1.8-.51,.1-.74-3.91Z"
            fill="#77787b"
          />
          <path
            d="M112.72,20.22c1.13-.22,2.15,.5,2.37,1.63s-.47,2.18-1.6,2.39c-1.13,.22-2.15-.5-2.37-1.63-.22-1.13,.47-2.18,1.6-2.39Zm.68,3.55c.85-.16,1.34-.96,1.18-1.82-.16-.86-.91-1.42-1.77-1.26-.85,.16-1.34,.96-1.18,1.82,.16,.86,.91,1.42,1.77,1.26Z"
            fill="#77787b"
          />
          <path
            d="M117,19.47l1.06-.2c.39-.07,.78-.13,1.13-.01,.36,.12,.63,.38,.71,.81,.08,.42-.06,.78-.33,1.01-.12,.11-.26,.19-.42,.25l1.58,1.48-.62,.12-1.51-1.45-.66,.13,.32,1.67-.51,.1-.75-3.91Zm1.52,1.59c.34-.07,.58-.16,.73-.32,.12-.14,.18-.31,.14-.53-.05-.25-.2-.42-.42-.5-.23-.07-.48-.04-.86,.03l-.51,.1,.26,1.35,.66-.13Z"
            fill="#77787b"
          />
          <path
            d="M122.11,18.49l1.02-.19c.42-.08,.82-.14,1.19-.02,.38,.12,.66,.4,.75,.86,.08,.44-.07,.82-.34,1.07-.3,.27-.75,.37-1.25,.47l-.4,.08,.29,1.54-.51,.1-.75-3.91Zm1.35,1.73c.46-.09,.71-.15,.91-.32,.17-.16,.25-.37,.2-.64-.06-.29-.23-.46-.48-.54-.26-.07-.55-.02-.91,.04l-.46,.09,.28,1.45,.47-.09Z"
            fill="#77787b"
          />
          <path
            d="M127.09,17.54l2.26-.43,.09,.46-1.74,.33,.23,1.19,1.53-.29,.08,.45-1.53,.29,.26,1.34,1.79-.34,.09,.46-2.3,.44-.75-3.91Z"
            fill="#77787b"
          />
          <path
            d="M135.1,19.23c.42,.21,.91,.24,1.26,.17,.46-.09,.75-.36,.67-.79-.1-.5-.57-.5-1.11-.55-.58-.05-1.16-.18-1.29-.89-.13-.69,.29-1.19,1.06-1.33,.37-.07,.83-.06,1.18,.08l.1,.54c-.4-.18-.87-.21-1.2-.15-.44,.08-.71,.33-.63,.73,.09,.49,.56,.48,1.06,.52,.6,.05,1.2,.17,1.34,.92,.14,.71-.31,1.23-1.09,1.38-.38,.07-.86,.06-1.24-.08l-.11-.56Z"
            fill="#77787b"
          />
          <path
            d="M140.34,15.5l-1.31,.25-.09-.46,3.13-.6,.09,.46-1.31,.25,.66,3.44-.51,.1-.66-3.44Z"
            fill="#77787b"
          />
          <path
            d="M144.24,14.27l1.06-.2c.39-.08,.77-.13,1.13-.01,.36,.12,.63,.38,.71,.81,.08,.42-.06,.78-.33,1.01-.12,.11-.26,.19-.42,.25l1.58,1.48-.62,.12-1.51-1.45-.66,.13,.32,1.67-.51,.1-.74-3.91Zm1.52,1.59c.35-.07,.58-.16,.73-.32,.12-.14,.18-.31,.14-.53-.05-.25-.2-.42-.42-.5-.23-.07-.48-.04-.86,.03l-.51,.1,.26,1.35,.66-.13Z"
            fill="#77787b"
          />
          <path
            d="M149.35,13.3l2.26-.43,.09,.46-1.74,.33,.23,1.19,1.53-.29,.08,.45-1.53,.29,.26,1.34,1.79-.34,.09,.46-2.3,.44-.75-3.91Z"
            fill="#77787b"
          />
          <path
            d="M153.95,12.42l2.25-.43,.09,.46-1.74,.33,.23,1.19,1.53-.29,.08,.45-1.53,.29,.26,1.34,1.79-.34,.09,.46-2.3,.44-.74-3.91Z"
            fill="#77787b"
          />
          <path
            d="M159.62,11.82l-1.31,.25-.09-.46,3.13-.6,.09,.46-1.31,.25,.66,3.44-.51,.1-.66-3.44Z"
            fill="#77787b"
          />
        </g>
        <g>
          <path
            d="M140.47,107.23h1.23c.5,0,.98,.02,1.39,.25,.41,.23,.68,.61,.68,1.16s-.26,.94-.64,1.17c-.41,.25-.96,.27-1.56,.27h-.49v1.86h-.62v-4.71Zm1.18,2.31c.55,0,.86-.02,1.12-.18,.23-.14,.38-.38,.38-.7,0-.35-.17-.59-.44-.73-.29-.14-.63-.15-1.07-.15h-.56v1.75h.57Z"
            fill="gray"
          />
          <path
            d="M144.45,110.69v-1.96h.58v1.85c0,.35,.05,.53,.16,.66,.13,.16,.32,.22,.51,.22,.4,0,.77-.26,1-.55v-2.18h.58v3.2h-.58v-.4h-.01c-.28,.27-.66,.47-1.11,.47-.32,0-.66-.11-.87-.36-.18-.21-.26-.5-.26-.96Z"
            fill="gray"
          />
          <path
            d="M148.31,106.97h.58v1.95h.01c.2-.12,.52-.25,.9-.25,.86,0,1.56,.66,1.56,1.62s-.72,1.72-1.7,1.72c-.3,0-.56-.07-.8-.17l-.57,.1v-4.97Zm1.38,4.52c.65,0,1.09-.5,1.09-1.17s-.41-1.13-1.04-1.13c-.34,0-.63,.12-.84,.3v1.79c.21,.12,.53,.21,.8,.21Z"
            fill="gray"
          />
          <path d="M152.18,106.97h.58v4.97h-.58v-4.97Z" fill="gray" />
          <path
            d="M154.09,107.23c.23,0,.41,.18,.41,.41s-.18,.41-.41,.41-.41-.18-.41-.41,.18-.41,.41-.41Zm-.29,1.51h.58v3.2h-.58v-3.2Z"
            fill="gray"
          />
          <path
            d="M157.88,111.78c-.27,.15-.63,.22-.96,.22-1.01,0-1.74-.7-1.74-1.65s.78-1.69,1.77-1.69c.33,0,.64,.08,.86,.2v.6c-.27-.17-.58-.27-.89-.27-.7,0-1.16,.51-1.16,1.16s.49,1.12,1.18,1.12c.36,0,.68-.12,.92-.31v.62Z"
            fill="gray"
          />
          <path
            d="M160.51,112.57c.31,.2,.66,.33,1.01,.33,.61,0,1.02-.36,1.02-.97v-.23h-.01c-.22,.14-.53,.24-.87,.24-.87,0-1.57-.66-1.57-1.6s.62-1.68,1.66-1.68c.33,0,.6,.08,.81,.18l.57-.1v3.17c0,.94-.62,1.51-1.61,1.51-.39,0-.75-.1-1.01-.24v-.62Zm1.23-1.14c.29,0,.6-.1,.8-.26v-1.76c-.2-.12-.51-.22-.81-.22-.64,0-1.05,.49-1.05,1.12s.43,1.12,1.06,1.12Z"
            fill="gray"
          />
          <path
            d="M164.29,111.78c-.21-.16-.34-.4-.34-.71,0-.36,.17-.62,.42-.78,.24-.16,.57-.21,.9-.21,.25,0,.47,.03,.68,.08v-.27c0-.23-.06-.41-.18-.53-.12-.11-.32-.18-.59-.18-.4,0-.74,.14-.98,.32v-.57c.25-.15,.59-.27,1.07-.27,.39,0,.73,.08,.96,.29,.19,.17,.32,.44,.32,.84v1.36c0,.2,.07,.34,.25,.34,.06,0,.14-.02,.19-.05v.49c-.08,.03-.19,.06-.31,.06-.25,0-.49-.11-.62-.34h-.01c-.18,.17-.55,.35-.98,.35-.26,0-.55-.06-.76-.23Zm1.66-.57v-.6c-.18-.05-.42-.08-.62-.08-.4,0-.79,.12-.79,.49,0,.31,.27,.47,.61,.47,.31,0,.6-.12,.8-.28Z"
            fill="gray"
          />
          <path
            d="M167.62,108.73h.58v.47h.01c.22-.31,.57-.49,.95-.49,.06,0,.14,0,.21,.03v.58c-.08-.02-.16-.03-.23-.03-.44,0-.74,.22-.94,.57v2.08h-.58v-3.2Z"
            fill="gray"
          />
          <path
            d="M171.41,108.66c.32,0,.56,.08,.77,.17h.01v-1.87h.58v4.97h-.58v-.19h-.01c-.21,.14-.51,.27-.9,.27-.86,0-1.57-.63-1.57-1.62s.69-1.72,1.7-1.72Zm-.05,2.82c.32,0,.6-.12,.83-.27v-1.83c-.21-.11-.5-.2-.79-.2-.68,0-1.1,.51-1.1,1.17s.4,1.13,1.05,1.13Z"
            fill="gray"
          />
          <path
            d="M174.17,110.5c.08,.63,.55,.98,1.18,.98,.44,0,.81-.18,1.1-.4v.62c-.29,.18-.73,.3-1.14,.3-.99,0-1.73-.66-1.73-1.67s.73-1.67,1.59-1.67c.78,0,1.46,.55,1.46,1.55,0,.1,0,.21-.02,.29h-2.44Zm.01-.46h1.88c-.05-.64-.52-.85-.9-.85-.42,0-.88,.26-.98,.85Z"
            fill="gray"
          />
          <path
            d="M177.47,108.73h.58v.4h.01c.28-.27,.67-.47,1.12-.47,.35,0,.65,.12,.85,.35,.18,.2,.27,.45,.27,.94v1.98h-.58v-1.87c0-.33-.05-.53-.15-.65-.13-.16-.34-.21-.51-.21-.36,0-.77,.23-1,.53v2.19h-.58v-3.2Z"
            fill="gray"
          />
          <path
            d="M181.22,111.13c.36,.23,.83,.34,1.22,.34,.44,0,.73-.13,.73-.44,0-.38-.46-.39-.96-.47-.61-.1-1.09-.29-1.09-.92,0-.66,.57-.98,1.31-.98,.38,0,.83,.08,1.14,.25v.58c-.36-.21-.8-.31-1.17-.31-.41,0-.7,.12-.7,.41,0,.36,.46,.36,.93,.45,.61,.1,1.12,.27,1.12,.94,0,.74-.66,1.02-1.35,1.02-.41,0-.86-.08-1.2-.26v-.61Z"
            fill="gray"
          />
        </g>
        <polygon
          points="41.5 22.58 38.66 37.39 41.5 38.92 70.57 26.77 69.46 24.65 64.79 23.6 57.62 26.13 41.5 22.58"
          fill="#f1f2f2"
        />
      </g>
      <g id="Outline">
        <path
          d="M-125.19-55.16V399.75H346.16V-55.16H-125.19ZM250.36,233.31H-3.38V-20.44H250.36V233.31Z"
          fill="#D0D0D0"
          stroke="#AAAAAA"
        />
      </g>
    </svg>
  )
})
